import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {SignedInContextService} from "@app/@shells/signed-in-shell/signed-in-context.service";
import {CheckedComponentInternal} from "@app/campaigns/campaign/@common/campaign-drafting/checked-component-internal";
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'app-campaign-billing-surname[campaignForm]',
  templateUrl: './campaign-billing-surname.component.html',
  styleUrls: ['./campaign-billing-surname.component.scss']
})
export class CampaignBillingSurnameComponent implements OnInit, OnChanges {
  @Input() campaignForm!: FormGroup;
  checked: CheckedComponentInternal;

  constructor(private signedInContextService: SignedInContextService) {
    this.checked = new CheckedComponentInternal('billingSurname', 'billingName');
  }

  ngOnInit(): void {
    this.applyComponentLogic();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['campaignForm'] && this.campaignForm) {
      this.applyComponentLogic();
    }
  }

  private applyComponentLogic(): void {
    const billingNameValue = this.campaignForm.get('billingSurname')?.value;
    this.checked.init(this.campaignForm);
    if (!billingNameValue) {
      this.signedInContextService.context$().subscribe(context => {
        const surname = context.user.surname;
        this.checked?.initChecked(surname);
      });
    }
  }
}
